import { render, staticRenderFns, recyclableRender, components } from "./detail.vue?vue&type=template&id=ee9019a0&scoped=true&"
var renderjs
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=ee9019a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_@dcloudio_vue-cli-plugin-uni@2.0.0-28320200727001@@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9019a0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/personalCenter/activity/detail.vue"
export default component.exports